<template>
  <div>
    <el-table :data="tableData" stripe style="width: 100%;" height="300px" class="custom-table">
      <el-table-column
          v-for="col in columns"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :width="col.width"
          show-overflow-tooltip
      >
        <template v-if="col.prop === 'AppointmentTime'" #default="scope">
          {{ scope.row.AppointmentTime === '0001-01-01T00:00:00Z' ? "————" : formatDate(scope.row.AppointmentTime) }}
        </template>
        <template v-if="col.prop === 'EndAppointmentTime'" #default="scope">
          {{ scope.row.EndAppointmentTime === '0001-01-01T00:00:00Z' ? "————" : formatDate(scope.row.EndAppointmentTime) }}
        </template>
        <template v-if="col.prop === 'ActualPickupTime'" #default="scope">
          {{ scope.row.ActualPickupTime === '0001-01-01T00:00:00Z' ? "————" : formatDate(scope.row.ActualPickupTime) }}
        </template>
        <template v-if="col.prop === 'AppointmentStatus'" #default="scope">
          {{ statusMap[scope.row.AppointmentStatus] || '未知状态' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200px" fixed="right">
        <template #default="scope">
          <slot name="actions" :row="scope.row"></slot>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: Array
  },
  data() {
    return {
      columns: [
        {prop: "BookBarcode", label: "图书条码"},
        {prop: "BookTitle", label: "正题名"},
        {prop: "ReaderName", label: "读者姓名"},
        {prop: "ReaderCardNumber", label: "读者卡号"},
        {prop: "AppointmentTime", label: "预约时间"},
        {prop: "AppointmentStatus", label: "预约状态"},
        {prop: "EndAppointmentTime", label: "过期时间"},
        {prop: "ActualPickupTime", label: "取书时间"}
      ],
      statusMap: {
        0: '预约成功',
        1: '预约锁定',
        2: '预约完成',
        3: '预约取消',
        4: '预约超期'
      }
    };
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const seconds = date.getSeconds().toString().padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }
};
</script>

<style scoped>
::v-deep .custom-table .cell {
  font-size: 12px;
}



::v-deep .custom-table .el-table__row {
  height: 0px; /* 调整行高，例如30px */
}

::v-deep .custom-table .el-table__cell {
  padding: 0px 8px; /* 调整单元格的内边距，例如4px上下，8px左右 */
  margin: 0; /* 清除单元格的外边距 */
  line-height: 0px;
}

::v-deep .custom-table .el-table__body-wrapper tbody tr {
  line-height: 0; /* 调整行内容的行高 */
}

::v-deep .custom-table .el-table .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>